module.exports = __webpack_public_path__ + "img/logo.54f77164.png";